import React from 'react';
import FieldValidation from '../Fragments/FieldValidation';
import FieldError from '../Fragments/FieldError';
import InputElement from 'react-input-mask';
import HelpIcon from '../Fields/HelpIcon';
import Modal from '../Fragments/Modal';

let Quote = require('../Managers/Quote.js');
let Validation = require('../Managers/Validation.js');

const MoneyInput = React.createClass({
    propTypes: {
        fieldName:  React.PropTypes.string.isRequired,
        helpText:   React.PropTypes.string,
        question:   React.PropTypes.string.isRequired,
        inputMask:  React.PropTypes.string.isRequired,
        supplementaryId:   React.PropTypes.string,
        alternateBackground: React.PropTypes.string,
        noBorder: React.PropTypes.string,
    },

    getInitialState() {
        return {
            isHelpVisible: false,
            isValid: (Quote.getCurrentAnswer(this.props.fieldName)) ? true : false,
            hasError: false,
            errors: null,
            isMspVisible: false,
            mspModal: false,
            modalButton: null,
        };
    },

    doValidation() {
        if (!Quote.hasAnswers(this.props.fieldName)) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        return true;
    },

    setActiveValue(event) {
        this.setState({
            activeValue: event.target.value,
            isValid: true
        });
        let validation = Validation.validate(this.getDomId(), event.target.value)[0];
        this.setState(validation);
        if (validation.isValid) {
            Quote.set(this.props.fieldName, event.target.value);
        } else {
            Quote.set(this.props.fieldName, "");
        }
        // todo: this is gross, but the questions are data driven, and this functionality needs to exist on one field only...
        if ('contents_amount' === this.props.fieldName && event.target.value > 29999 && event.target.value < 60000) {
            this.setState({
                isMspVisible: true,
                modalButton: {
                    classes: "btn btn-success",
                    text: "I UNDERSTAND",
                }
            });
        } else {
            this.setState({ isMspVisible: false });
        }
    },

    toggleHelpText: function() {
        this.setState({
            isHelpVisible: (this.state.isHelpVisible) ? false : true,
        });
    },

    closeMspModal() {
        this.setState({ isMspVisible: false });
    },

    getDomId() {
        let id = this.props.fieldName;
        if (this.props.supplementaryId != null) {
            id += '_' + this.props.supplementaryId;
        }
        return id;
    },

    render() {
        let containerClass = '';
        if (this.props.alternateBackground) {
            containerClass = 'alternate-background';
        }

        let questionRowClass = '';
        if (this.props.noBorder) {
            questionRowClass = 'no-border';
        }

        let id = this.getDomId();
        let topClass = (this.props.helpText) ? 'question-top with-help' : 'question-top without-help';
        return (
            <div className={containerClass}>
                <question-row class={questionRowClass}>
                    <div className="question-main">
                        <div className={topClass}>
                            <label>{this.props.question}</label>
                            {this.props.helpText ? <HelpIcon onClick={this.toggleHelpText} />: null}
                        </div>
                        <div className="question-input">
                            <div className="input-group money-group">
                                <span className="input-group-addon left">&pound;</span>
                                <InputElement
                                    name={this.props.fieldName}
                                    id={id}
                                    className="right"
                                    mask={this.props.inputMask}
                                    maskChar={null}
                                    onBlur={this.setActiveValue}
                                    defaultValue={Quote.getCurrentAnswer(this.props.fieldName)}
                                />
                            </div>

                            {this.state.isHelpVisible ? (
                                <div className="hint-container">
                                    <div className="hint">
                                        <div className="arrow arrow-left" />
                                        {this.props.helpText}
                                    </div>
                                </div>
                            ) : null}
                            {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                        </div>
                    </div>
                    <div className="question-extra">
                        <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                    </div>
                    {this.state.isMspVisible === true ?
                        <Modal
                            title="Theft Risk Area"
                            isActive={true}
                            bodyTemplate="msp"
                            closeFunction={this.closeMspModal}
                            closeButton={this.state.modalButton}
                            hasFooter={true}
                        />
                    : null}
                </question-row>
            </div>
        );
    }
});

export default MoneyInput;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/MoneyInput.js
 **/